import { Button, ButtonProps, Flex, FlexProps } from '@chakra-ui/react';
import React from 'react';

interface Props extends ButtonProps {
  isHighlighted: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  testId?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  borderRadius?: FlexProps['borderRadius'];
}

const FilterPillButton = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      isHighlighted,
      isSelected,
      isDisabled,
      testId,
      children,
      leftIcon,
      rightIcon,
      borderRadius = 'md',
      ...props
    },
    ref,
  ) => {
    return (
      <Button
        variant="ghost"
        ref={ref}
        {...props}
        data-testid={testId}
        fontWeight={isHighlighted ? 'bold' : 'medium'}
        size="xs"
        bgColor={isSelected || isHighlighted ? 'surface.accent' : ''}
        borderRadius={borderRadius}
        fontSize="xs"
        borderWidth={isHighlighted ? 0 : 1}
        boxShadow="none"
        cursor="pointer"
        disabled={isDisabled}
        borderColor={isSelected || isHighlighted ? 'border.emphasized' : 'border.light'}
        _hover={{
          backgroundColor: 'surface.accent',
        }}
        _disabled={{
          color: 'gray.400',
          bgColor: 'gray.50',
          borderColor: 'surface.background',
          cursor: 'default',
        }}
        _focusVisible={{
          boxShadow: 'none',
        }}
      >
        {leftIcon}
        <Flex overflow="hidden" textOverflow="ellipsis" maxW="15rem">
          {children}
        </Flex>
        {rightIcon}
      </Button>
    );
  },
);

FilterPillButton.displayName = 'FilterPillButton';

export default FilterPillButton;
